import {default as _, filter, values} from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { Subscription } from 'rxjs';
import { APIURL } from '../../../Shared/Constant/API_Urls';
import { GridService } from '../../../Shared/Services/grid.service';
import { SharedHttpClientService } from '../../../Shared/Services/shared-http-client.service';
import { UrlsService } from '../../../Shared/Services/urls.service';
import { UserService } from '../../../Shared/Services/user.service';
import { MenuItem, MessageService,ConfirmationService } from 'primeng/api';
import {default as DataGridColumnsJSON} from './CAT-Recon-Grid-Columns.json';
import { Router } from "@angular/router";
import { endOfMonth, format, startOfMonth } from 'date-fns';
import { CatReconService } from './cat-recon.service';
import { Table, TableModule } from 'primeng/table';
import { DecimalPipe, LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { FilterPanelComponent } from 'app/Shared/Component/filter-panel/filter-panel.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CatReconCommentViewerComponent } from 'app/Shared/Component/cat-recon-comment-viewer/cat-recon-comment-viewer.component';
import { ContextMenu,ContextMenuModule } from 'primeng/contextmenu';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { asBlob, generateCsv } from 'export-to-csv';
import { saveAs } from 'file-saver';
import { ExportToCSVSComponent } from 'app/Shared/Component/export-to-csv/export-to-csv.component';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { QuickSearchComponent } from 'app/Shared/Component/quick-search/quick-search.component';
import { AccordionModule } from 'primeng/accordion';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-cat-recon',
    templateUrl: './cat-recon.component.html',
    styleUrls: ['./cat-recon.component.scss'],
    imports: [NgClass, CommonModule, ButtonModule, MatTooltipModule, TableModule,
        FilterPanelComponent, MatProgressSpinnerModule, LowerCasePipe,
        ConfirmDialogModule, DecimalPipe, CatReconCommentViewerComponent, ContextMenuModule,
        MenubarModule, MenuModule, ExportToCSVSComponent, QuickSearchComponent, AccordionModule, MatChipsModule, MatIconModule]
})
export class CatReconComponent implements OnInit, OnDestroy {
[x: string]: any;
  @ViewChild(ContextMenu) public ContextMenuObject!: ContextMenu;
  @ViewChild('cm') cm!: ContextMenu;

  @ViewChild(('dt')) dt!: Table | any;
  @ViewChild(('dt1')) dt1!: Table | any;
  @ViewChild(('dt2')) dt2!: Table | any;

  CATReconSummaryHTTPSubscribedAPI: any;
  CATReconCommentHTTPSubscribedAPI: any;
  msgs!: any[];
  tbldatamsg = "L o a d i n g . . . . .";
  reportDate: any;
  eventTypes: any;
  orderTypes: any;
  commentCriteria: any;
  commentField?: any;
  commentFieldHeader?: any;
  commentGroupName?: any;
  LastExecutionCATDate!: any[];
  DefaultFilterArray: any = [];
  selectedTabIndex: number = 1;
  selectedPrevMonth: any;
  hasUserOptedCATMonthlyFilter: boolean = false;
  clientAndcatTab: boolean = true;
  clientDataTab: boolean = false;
  catDataTab: boolean = false;
  catSubmissionTab: boolean = false;
  catMonthlySummaryTab: boolean = false;
  isClientCATDataLoadingResults = true;
  isClientDataLoadingResults = true;
  isCATDataLoadingResults = true;
  isCATSubmissionDataLoadingResults = true;
  isCATMonthlySummaryDataLoadingResults = true;
  ClientCATSummaryGridColumns = DataGridColumnsJSON["ClientCatSummaryCols"];
  ClientCATDetailGridColumns = DataGridColumnsJSON["ClientCatDetailCols"];
  ClientDataGridColumns = DataGridColumnsJSON["ClientDataCols"];
  CATDataGroupSummaryGridColumns = DataGridColumnsJSON["CATDataGroupSummaryCols"];
  CATDataGridColumns = DataGridColumnsJSON["CATDataCols"];
  CorrectedCATSubmissionGridColumns = DataGridColumnsJSON["CorrectedCATSubmissionCols"];
  SubmittedCATSubmissionGridColumns = DataGridColumnsJSON["SubmittedCATSubmissionCols"];
  CATMonthlyFinraSubmissionSummaryGridColumns = DataGridColumnsJSON["CATMonthlyFinraSubmissionSummaryCols"];
  CATMonthlyFinraRejectionSummaryGridColumns = DataGridColumnsJSON["CATMonthlyFinraRejectionSummaryCols"];
  MissingClientRecordsColumns = DataGridColumnsJSON["MissingClientRecordsCols"];
  MissingCATRecordsColumns = DataGridColumnsJSON["MissingCATRecordsCols"];
  missingCATRecordsCols: any =[];
  missingClientRecordsCols: any =[];
  clientCATSummaryCols: any = [];
  clientCATDetailCols: any = [];
  clientDataCols: any = [];
  catDataGroupSummaryCols: any = [];
  catDataCols: any = [];
  correctedCATSubmissionCols: any = [];
  submittedCATSubmissionCols: any = [];
  catMonthlyFinraSubmissionSummaryCols?: any = [];
  catMonthlyFinraRejectionSummaryCols?: any = [];
  clientCATDataSet: any[] = [];
  missingClientData: any[]=[];
  missingCATRecordData: any[]=[];
  clientCATDetailDataSet: any[] = [];
  clientDataSet: any[] = [];
  CATDataGroupDataSet: any[] = [];
  CATDataSet: any[] = [];
  CATCorrectedDataSet: any[] = [];
  CATSubmittedDataSet: any[] = [];
  CATMonthlySummaryDataSet?: any[] | any = [];
  CATMonthlySummaryTotals: Object|any = new Object();
  commentStatement: any;
  Limit: any = { 'Start': '', 'End': '' };
  previousLimit: any = { 'Start': '', 'End': '' };
  totalRecords : number = 0;
  totalRecordsCATRecord : number = 0;
  totalRecordsMissinClient: number =0;
  count: any = 0;
  previousMonths: any = [];
  CATMonthlyDateRangeFilter: any = [];
  panelNames: any[] = ['', 'Client & CAT', 'Client Data', 'CAT Data', 'CAT Submission', 'CAT Monthly Summary'];
  panelKeys: any[] = ['', 'clientCAT', 'clientData', 'catData', 'catSubmission', 'catMonthlySummary'];
  CATGroupByCommentCount:any = new Object();
  quickFilterArrayForUnderReporting: any;
  quickFilterArrayForMissingData:any;
  DefaultFilterArrayForUnderReporting:any =[];
  DefaultFilterArrayForMissingData:any =[];
  reconTypeForUnderReporting='U';
  reconTypeForMissingData='M';
  category:any='';
  isForUnderReportingLoadingResults = true;
  isForMissingDataLoadingResults = true;
  groupNames: Array<string> = [];



  private subscription!: Subscription;
  selectedRowData: any = [];
  filterByName: string = '';
  tableName: string = '';
  commentCount = 0;
  totalCommentsCount: any = 0;
  items: MenuItem[] | any;
  groupListDropDown: any = [];
  selectedGroup: any;
  selectRowIndex: any;
  missingClientfirst:any = 1;
  underreportingfirst:any = 1;
  startLimit: number = 0;
  endLimit!: number;
  pageNumber: any = 1;
  rowcount!: number;
  sortData:any = { field: '', order: 0};
  sortClickCounter: number = 0;

  limitForUnderReporting: any = { 'Start': '', 'End': '' };
  limitForMissingData: any = { 'Start': '', 'End': '' };
  previousLimitForUnderReporting: any = { 'Start': '', 'End': '' };
  previousLimitForMissingData: any = { 'Start': '', 'End': '' };
  startLimitForUnderReporting: number = 0;
  endLimitForUnderReporting!: number;
  startLimitForMissingData: number = 0;
  endLimitForMissingData!: number;
  leftAlignedColumns: string[] = ['File Name'];


  constructor(
    private gridService: GridService,
    private emitterService: EmitterService,
    private sharedHttpClientService: SharedHttpClientService,
    private urlsService: UrlsService,
    public constantService: ConstantService,
    private userService: UserService,
    private messageService: MessageService,
    private router: Router,
    public confirmationService: ConfirmationService,
    public catReconService: CatReconService,
    private sortPipe:SortPipe) {
      this.quickFilterArrayForUnderReporting = DataGridColumnsJSON['quick-Search-FilterForUnderReporting'];
      this.quickFilterArrayForMissingData = DataGridColumnsJSON['quick-Search-FilterForMissingData']
      this.reportDate = this.userService.getyyyyMMddDateFormate(this.userService.CATLastExecutionDate);
      let catFieldDictionary = this.userService.getDropDownList('type');
      if(catFieldDictionary && catFieldDictionary.length > 0) {
        this.eventTypes = catFieldDictionary.map((eventType:any) => eventType.value);
      }
      this.orderTypes = Object.keys(this.constantService.EVENT_DESCRIPTION_BY_EVENT_TYPE);
  }

  ngOnInit(): void {
    /*** Get Last CAT Execution date*/
    let todate: any;
    todate = this.userService.CATLastExecutionDate;

    this.LastExecutionCATDate = [];
    if (todate != "" && todate != undefined && todate != null) {
      this.LastExecutionCATDate[0] = (todate);
      this.LastExecutionCATDate[1] = (todate);
      this.defaultFilter();
    }

    this.getPreviousMonths(); // Get All 12 Previous Months
    this.getOptedMonthDates(format(this.userService.CATLastExecutionDate, 'MMM-yyyy')); // Get Default Report Dates

    this.getColumns(); // Get & Prepare all Tables Column Details

    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.isClientCATDataLoadingResults = true;
        this.isClientDataLoadingResults = true;
        this.isCATDataLoadingResults = true;
        this.isCATSubmissionDataLoadingResults = true;
        this.isCATMonthlySummaryDataLoadingResults = true;

        /* Maintain consistency of CAT Monthly Summary Result when changing different Firm from Mater User Account */
          this.userService.get_CAT_Last_ReportDate().subscribe(apiResult => {
            let response: any = apiResult;
            let apiResponse = response.data[0];
            if(apiResponse) {
              this.userService.CATLastExecutionDate = (apiResponse.CATLastExcecutionReportDate !== "" ? this.userService.getFormatedDate(apiResponse.CATLastExcecutionReportDate) : new Date());
              this.getPreviousMonths(); // Get All 12 Previous Months
                this.getOptedMonthDates(format(this.userService.CATLastExecutionDate, 'MMM-yyyy')); // Get Default Report Dates
              this.getData();
            }
          });
        /* End of Maintain consistency of CAT Monthly Summary Result when changing different Firm from Mater User Account */
      }
    });
    this.items = [
      {
          label: 'Add Comment',
          command: () => {
            this.prepareAndSendContextMenuParams(this.commentCriteria, this.commentField, this.commentFieldHeader, this.commentGroupName);
          }
      },      
  ];
  this.rowcount = this.constantService.DEFAULT_ROWSIZE;
    this.endLimitForUnderReporting = this.rowcount;
    this.limitForUnderReporting = { 'Start': '0', 'End': this.endLimitForUnderReporting };
    this.endLimitForMissingData = this.rowcount;
    this.limitForMissingData = { 'Start': '0', 'End': this.endLimitForMissingData };
    this.totalRecordsCATRecord = this.rowcount;
    this.totalRecordsMissinClient = this.rowcount;



  }

  getColumns() {
    // Client & CAT Screen Columns
    let clientCATSummaryGridcolumn: any = this.ClientCATSummaryGridColumns;
    this.clientCATSummaryCols = this.gridService.getGridColumns(clientCATSummaryGridcolumn);
    this.clientCATSummaryCols.map((data:any) => { data['tableName'] = "Event Summary Table" }); // Set Table Name for Header

    let clientCATDetailGridcolumn: any = this.ClientCATDetailGridColumns;
    this.clientCATDetailCols = this.gridService.getGridColumns(clientCATDetailGridcolumn);
    this.clientCATDetailCols.map((data:any) => { data['tableName'] = "File Details Table" }); // Set Table Name for Header

    // Client Data Screen Columns
    let clientDataGridcolumn: any = this.ClientDataGridColumns;
    this.clientDataCols = this.gridService.getGridColumns(clientDataGridcolumn);
    this.clientDataCols.map((data:any) => { data['tableName'] = "Client File Details Table" }); // Set Table Name for Header

    // CAT submission Screen Columns
    let catDataGroupSummaryGridcolumn: any = this.CATDataGroupSummaryGridColumns;
    this.catDataGroupSummaryCols = this.gridService.getGridColumns(catDataGroupSummaryGridcolumn);
    this.catDataGroupSummaryCols.map((data:any) => { data['tableName'] = "CAT Singular Group Detail Table" }); // Set Table Name for Header

    let catDataGridcolumn: any = this.CATDataGridColumns;
    this.catDataCols = this.gridService.getGridColumns(catDataGridcolumn);
    this.catDataCols.map((data:any) => { data['tableName'] = "CAT Group Details Table" }); // Set Table Name for Header

    // CAT Data Screen Columns
    let correctedCATSubmissionGridColumn: any = this.CorrectedCATSubmissionGridColumns;
    this.correctedCATSubmissionCols = this.gridService.getGridColumns(correctedCATSubmissionGridColumn);
    this.correctedCATSubmissionCols.map((data:any) => { data['tableName'] = "Submission Corrected Details Table" }); // Set Table Name for Header

    let submittedCATSubmissionGridColumn: any = this.SubmittedCATSubmissionGridColumns;
    this.submittedCATSubmissionCols = this.gridService.getGridColumns(submittedCATSubmissionGridColumn);
    this.submittedCATSubmissionCols.map((data:any) => { data['tableName'] = "Submission Submitted Details Table" }); // Set Table Name for Header

    // CAT Monthly Summary Columns
    let CATMonthlyFinraSubmissionSummaryGridColumn: any = this.CATMonthlyFinraSubmissionSummaryGridColumns;
    this.catMonthlyFinraSubmissionSummaryCols = this.gridService.getGridColumns(CATMonthlyFinraSubmissionSummaryGridColumn);
    this.catMonthlyFinraSubmissionSummaryCols.map((data:any) => { data['tableName'] = "CAT Monthly Summary Table" }); // Set Table Name for Header

    let CATMonthlyFinraRejectionSummaryGridColumn: any = this.CATMonthlyFinraRejectionSummaryGridColumns;
    this.catMonthlyFinraRejectionSummaryCols = this.gridService.getGridColumns(CATMonthlyFinraRejectionSummaryGridColumn);
    this.catMonthlyFinraRejectionSummaryCols.map((data:any) => { data['tableName'] = "CAT Monthly Summary Table" }); // Set Table Name for Header
    
    // Missing Client Data Screen Columns
    let missingClientRecordsDataGridcolumn: any = this.MissingClientRecordsColumns;
    this.missingClientRecordsCols = this.gridService.getGridColumns(missingClientRecordsDataGridcolumn);
    this.missingClientRecordsCols.map((data:any) => { data['tableName'] = "Missing Client File Details Table" }); // Set Table Name for Header
   
    // Missing CAT Data Screen Columns
    let missingCATRecordsDataGridcolumn: any = this.MissingCATRecordsColumns;
    this.missingCATRecordsCols = this.gridService.getGridColumns(missingCATRecordsDataGridcolumn);
    this.missingCATRecordsCols.map((data:any) => { data['tableName'] = "Missing CAT File Details Table" }); // Set Table Name for Header
  }

  getPreviousMonths() {
    this.previousMonths = [];

    /* Receive Last CAT Execution Date */
    let currentDate: any = new Object();
    currentDate = { executableDate: this.userService.CATLastExecutionDate };
    let clonedCurrentDate = _.cloneDeep(currentDate);

    this.previousMonths.push(format(clonedCurrentDate.executableDate, 'MMM-yyyy')); // Add Last CAT Execution Date's Month in Previous Month List

    /* Add past 12 months from Last CAT Execution Date's Month in Previous Month List */
    for(let i = 12; i > 0; i--) {
      clonedCurrentDate.executableDate.setDate(1); // Set to the 1st of the current month
      clonedCurrentDate.executableDate.setMonth(clonedCurrentDate.executableDate.getMonth() - 1);
      this.previousMonths.push(format(clonedCurrentDate.executableDate, 'MMM-yyyy'));
    }
  }

  getOptedMonthDates(optedMonth:any) {
    let optedMonthName = optedMonth.substring(0, optedMonth.indexOf('-')); // Get Opted Month Name
    let optedMonthYear = parseInt(optedMonth.substring(optedMonth.indexOf('-') + 1)); // Get Opted Month's Year
    let optedMonthNumber = parseInt(format(new Date(optedMonthYear, new Date(optedMonthName + " 1, " + optedMonthYear).getMonth(), 1), "M")); // Get Opted Month in Number

    let initialDate = new Date(optedMonthYear, optedMonthNumber - 1, 1); // Set Opted Month's First Date
    let lastDate = new Date(optedMonthYear, optedMonthNumber, 0); // Set Opted Month's Last Date

    this.selectedPrevMonth = optedMonth; // Set User Opted Month with Year (MMM-YYYY)

    /* Set User Opted Month's Date Range for CAT Monthly Summary Result */
    this.CATMonthlyDateRangeFilter = [];
    this.CATMonthlyDateRangeFilter[0] = (initialDate);
    this.CATMonthlyDateRangeFilter[1] = (lastDate);

    this.hasUserOptedCATMonthlyFilter = true; // Set User Opted Monthly Filter flag

    /* Fetch fresh Data when Monthly Filter is applied */
    let CATDefaultFilterData = _.cloneDeep(this.CATMonthlyDateRangeFilter);
    this.getAllCommentCounts(); // Recall Comment Counts API
    this.getCATMonthlySummaryData(CATDefaultFilterData);
  }

  getOptedTab(tabIndex: number, tabText: string) {

    this.clientAndcatTab =  (tabText.includes('Client & CAT') ? true : false);
    this.clientDataTab = (tabText.includes('Client Data') ? true : false);
    this.catDataTab = (tabText.includes('CAT Data') ? true : false);
    this.catSubmissionTab = (tabText.includes('CAT Submission') ? true : false);
    this.catMonthlySummaryTab = (tabText.includes('CAT Monthly Summary') ? true : false);
    this.selectedTabIndex = tabIndex;
 

    if (this.clientAndcatTab) {
      this.tableName = "Event Summary Table";
    } else if (this.clientDataTab) {
      this.tableName = "Client File Details Table";
    } else if (this.catDataTab) {
      this.tableName = "CAT Group Details Table";
    } else if (this.catSubmissionTab) {
      this.tableName = "Submission Summary Table";
    } else if (this.catMonthlySummaryTab) {
      this.tableName = "CAT Monthly Summary Table";
    } 
  }

  FilterApplyFilterEvent(event:any) {
    // Reset CAT Monthly Filter, Opted Month
    this.selectedPrevMonth = '';
    this.hasUserOptedCATMonthlyFilter = false;
    this.CATMonthlyDateRangeFilter = [];

    // Reset CAT Recon Default Filter
    this.DefaultFilterArray = [];
    this.DefaultFilterArray = event;
    this.DefaultFilterArray.forEach((filterdata:any)=>{
      if(filterdata.columnname === 'reportDate'){
        this.syncDate(filterdata.values);
      }
      if(filterdata.columnname === 'groupName'){
        this.syncgroup(filterdata.values);
      }   
     });
    this.startLimit = 0;
    this.Limit.Start = 0;
    this.startLimitForUnderReporting = 0;
    this.limitForUnderReporting.Start = 0;
    this.startLimitForMissingData = 0;
    this.limitForMissingData.Start = 0;

    this.pageNumber = 1;
    this.dt.first = this.startLimit;
    this.dt1.first = this.startLimitForUnderReporting;
    this.dt2.first = this.startLimitForMissingData;
    this.resetCounts();
    this.getData();
  }

  defaultFilter() {
    if (this.reportDate) {
      this.LastExecutionCATDate = [];
      this.LastExecutionCATDate.push(this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.reportDate)));
      this.LastExecutionCATDate.push(this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.reportDate)));
    }

    this.DefaultFilterArray = [
      { "isdefault": "true", "label": "Date", "columnname": "reportDate", "filterby": "IS", "values": this.LastExecutionCATDate, "time": "", "datatype": "DateRange", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "Group Name", "columnname": "groupName", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },

    ];
    this.DefaultFilterArrayForUnderReporting = [
      { "isdefault": "true", "label": "Date", "columnname": "reportDate", "filterby": "IS", "values": this.LastExecutionCATDate, "time": "", "datatype": "DateRange", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "Group Name", "columnname": "groupName", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "Event", "columnname": "type", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "OrderID", "columnname": "orderID", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "RouteID", "columnname": "routeID", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "Symbol", "columnname": "Symbol", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" }

    ];
    this.DefaultFilterArrayForMissingData = [
      { "isdefault": "true", "label": "Date", "columnname": "reportDate", "filterby": "IS", "values": this.LastExecutionCATDate, "time": "", "datatype": "DateRange", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "Group Name", "columnname": "groupName", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "Event", "columnname": "type", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "OrderID", "columnname": "orderID", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "RouteID", "columnname": "routeID", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" },
      { "isdefault": "true", "label": "Symbol", "columnname": "Symbol", "filterby": "IS", "values": "", "time": "", "datatype": "String", "disabled": "true", "dropdown": "", "dropdownvalue": "" }

    ];

    this.getData();
  }

  getData() {
    this.tbldatamsg = "L o a d i n g . . . . .";
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    const filterDataforU =JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
    const filterDataForM =JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
    this.getClientandCATData(filterData);
    this.getClientData(filterData);
    this.getCATData(filterData);
    this.getCATSubmissionData(filterData);
    /* Call if User has applied CAT Recon Filter */
    if(!this.hasUserOptedCATMonthlyFilter) {
      this.getCATMonthlySummaryData(filterData);
    }
    this.getAllCommentCounts();
    this.getClientandCATMissingData(filterDataforU,"U");
    this.getClientandCATMissingData(filterDataForM,"M");
  }

  getClientandCATData(filterData?: any) {
    this.isClientCATDataLoadingResults = true;
    this.clientCATDataSet = [];
    this.clientCATDetailDataSet = [];
    this.reportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportType: 1,
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate),
      groupName:this.selectedGroup
    }

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAT_RECON
      ), payload
    )
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        if (dataset.length === 0) {
          this.tbldatamsg = "No data found";
        } else {
          this.prepareClientandCATData(dataset);
          this.groupListDropDown = dataset.GroupNameList;
        }
        this.isClientCATDataLoadingResults = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isClientCATDataLoadingResults = false;
      }
    });
  }

  getClientData(filterData?: any) {
    this.isClientDataLoadingResults = true;
    this.clientDataSet = [];
    this.reportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportType: 2,
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate)
    }

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAT_RECON
      ), payload
    )    
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        this.clientDataSet = dataset.ClientData;
        if (this.clientDataSet.length == 0) {
          this.tbldatamsg = "No data found";
        } else{
          this.clientDataSet.map((data)=>{
            data['tableName'] = "Client File Details Table";
          })
        }
        this.isClientDataLoadingResults = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isClientDataLoadingResults = false;
      }
    });
  }

  getCATData(filterData?: any) {
    this.isCATDataLoadingResults = true;
    this.CATDataGroupDataSet = [];
    this.CATDataSet = [];
    this.reportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportType: 3,
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate)
    }

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAT_RECON
      ), payload
    )   
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
            if (dataset.length === 0) {
              this.tbldatamsg = "No data found";
            } else {
              this.clientDataSet.map((data)=>{
                data['tableName'] = "CAT Group Details Table";
              });
              this.prepareCATData(dataset);
            }
            this.isCATDataLoadingResults = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isCATDataLoadingResults = false;
      }
    });
  }

  getCATSubmissionData(filterData?: any) {
    this.isCATSubmissionDataLoadingResults = true;
    this.CATCorrectedDataSet = [];
    this.CATSubmittedDataSet = [];
    this.reportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportType: 4,
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate)
    }

    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAT_RECON), payload
    )    
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        if (dataset.CATSubmissionData.length == 0) {
          this.tbldatamsg = "No data found";
        } else {         
          this.prepareCATSubmissionData(dataset.CATSubmissionData);
        }
        this.isCATSubmissionDataLoadingResults = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isCATSubmissionDataLoadingResults = false;
      }
    });
  }

  getCATMonthlySummaryData(filterData?: any) {
    // Cancel All Previously Pending Status APIs
    if (this.CATReconSummaryHTTPSubscribedAPI) {
      this.CATReconSummaryHTTPSubscribedAPI.unsubscribe();
    }

    this.isCATMonthlySummaryDataLoadingResults = true;
    this.CATMonthlySummaryDataSet = [];

    let initialReportDate = "", endReportDate = "";

    /* Check whether User has Opted CAT Monthly Filter OR CAT Recon Filter */
    if(this.hasUserOptedCATMonthlyFilter) {
      initialReportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0])));
      endReportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[1])));
    } else {
      initialReportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      endReportDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }

    let payload = {
      mpid: this.userService.getActiveMPID(),
      reportType: 5,
      initialReportDate: this.userService.getyyyyMMddDateFormate(initialReportDate),
      endReportDate: this.userService.getyyyyMMddDateFormate(endReportDate)
    }

    this.CATReconSummaryHTTPSubscribedAPI = this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAT_RECON), payload
    )   
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
        if (dataset.length === 0) {
          this.tbldatamsg = "No data found";
        } else {
          this.prepareCATMonthlySummaryData(dataset);
        }
        this.isCATMonthlySummaryDataLoadingResults = false;
      },
      error: (err: HttpErrorResponse) => {
        this.isCATMonthlySummaryDataLoadingResults = false;
      }
    });
  }

  prepareCATSubmissionData(CATDetail:any) {
    if(CATDetail.length > 0) {
      let correctedCATSubmissionData = [];
      let submittedCATSubmissionData = [];

      for(let i=0;i<CATDetail.length;i++) {
        /* Retrieving Corrected Data (Skipping Finra Named Error Exception Files also) */
          if(!CATDetail[i].fileName.startsWith("93006") && !CATDetail[i].fileName.startsWith(this.userService.CRDID) && CATDetail[i].fileKind === 'DATA') {
            if(correctedCATSubmissionData.length > 0) {
              for(let j=0;j<correctedCATSubmissionData.length;j++) {
                if(CATDetail[i]["reporter"] === correctedCATSubmissionData[j]["reporter"] && CATDetail[i]["groupname"] === correctedCATSubmissionData[j]["groupname"] && CATDetail[i]["fileName"] === correctedCATSubmissionData[j]["fileName"]) {
                  let correctedCATSubmissionDataGroupCount = CATDetail.filter((item:any) => !item.fileName.startsWith("93006") && item.fileKind === 'DATA' && item.reporter === correctedCATSubmissionData[j]["reporter"] && item.groupname === correctedCATSubmissionData[j]["groupname"]).length;
                  correctedCATSubmissionData[j]["fileCount"] = correctedCATSubmissionDataGroupCount;
                } else {
                  let correctedCATSubmissionDataGroupCount = CATDetail.filter((item:any) => !item.fileName.startsWith("93006") && item.fileKind === 'DATA' && item.reporter === CATDetail[i]["reporter"] && item.groupname === CATDetail[i]["groupname"]).length;
                  CATDetail[i]["fileCount"] = correctedCATSubmissionDataGroupCount;
                  correctedCATSubmissionData.push(CATDetail[i]);
                  break;
                }
              }
            } else {
              let correctedCATSubmissionDataGroupCount = CATDetail.filter((item:any) => !item.fileName.startsWith("93006") && !item.fileName.startsWith(this.userService.CRDID) && item.fileKind === 'DATA' && item.reporter === CATDetail[i]["reporter"] && item.groupname === CATDetail[i]["groupname"]).length;
              CATDetail[i]["fileCount"] = correctedCATSubmissionDataGroupCount;
              correctedCATSubmissionData.push(CATDetail[i]);
            }
          }
        /* End of Retrieving Corrected Data */
        /* Retrieving Submitted Data */
          if(CATDetail[i].fileName.startsWith("93006")) {
            let dataFilename = CATDetail[i].fileName.substring(0, CATDetail[i].fileName.indexOf('.'));

            if(CATDetail[i].fileKind === 'DATA') {
              if(dataFilename.includes("_5000")) {
                CATDetail[i]["repairFile"] = "REPAIR";
              } else if(dataFilename.includes("_8000")) {
                CATDetail[i]["repairFile"] = "SPECIAL";
              } else if(dataFilename.includes("linkage")) {
                CATDetail[i]["repairFile"] = "LINKAGE";
              }
              CATDetail[i]['finraRecordCount'] = CATDetail[i]['finraFileModified'] = CATDetail[i]['ingestionRecordCount'] = CATDetail[i]['ingestionFileModified'] = CATDetail[i]['integrityRecordCount'] = CATDetail[i]['integrityFileModified'] = CATDetail[i]['linkingRecordCount'] = CATDetail[i]['linkingFileModified'] = '';

              if(submittedCATSubmissionData.length > 0) {
                for(let j=0;j<submittedCATSubmissionData.length;j++) {
                  if(CATDetail[i]["reporter"] === submittedCATSubmissionData[j]["reporter"] && CATDetail[i]["groupname"] === submittedCATSubmissionData[j]["groupname"] && CATDetail[i]["fileName"] === submittedCATSubmissionData[j]["fileName"]) {
                    let submittedCATSubmissionDataGroupCount = CATDetail.filter((item:any) => !item.fileName.startsWith("93006") && item.fileKind === 'DATA' && item.reporter === submittedCATSubmissionData[j]["reporter"] && item.groupname === submittedCATSubmissionData[j]["groupname"]).length;
                    submittedCATSubmissionData[j]["fileCount"] = (submittedCATSubmissionDataGroupCount > 0 ? submittedCATSubmissionDataGroupCount : '');
                  } else {
                    let submittedCATSubmissionDataGroupCount = CATDetail.filter((item:any) => !item.fileName.startsWith("93006") && item.fileKind === 'DATA' && item.reporter === CATDetail[i]["reporter"] && item.groupname === CATDetail[i]["groupname"]).length;
                    CATDetail[i]["fileCount"] = (submittedCATSubmissionDataGroupCount > 0 ? submittedCATSubmissionDataGroupCount : '');
                    submittedCATSubmissionData.push(CATDetail[i]);
                    break;
                  }
                }
              } else {
                let submittedCATSubmissionDataGroupCount = CATDetail.filter((item:any) => !item.fileName.startsWith("93006") && item.fileKind === 'DATA' && item.reporter === CATDetail[i]["reporter"] && item.groupname === CATDetail[i]["groupname"]).length;
                CATDetail[i]["fileCount"] = (CATDetail[i]["reporter"] !== CATDetail[i]["groupname"] ? submittedCATSubmissionDataGroupCount : '');
                submittedCATSubmissionData.push(CATDetail[i]);
              }
            } 
          }
        /* End of Retrieving Submitted Data */
      }

    this.prepareCatFeedbackDetails(CATDetail,submittedCATSubmissionData);


      if(correctedCATSubmissionData.length > 0) {
        correctedCATSubmissionData.map((data) => { data['tableName'] = "Submission Corrected Details Table"; }); // Set Table Name for Cell Value
        this.CATCorrectedDataSet = correctedCATSubmissionData;
      }
      if(submittedCATSubmissionData.length > 0) {
        submittedCATSubmissionData.map((data) => { data['tableName'] = "Submission Submitted Details Table"; }); // Set Table Name for Cell Value
        this.CATSubmittedDataSet = submittedCATSubmissionData;
      }
    }
  }


  prepareCatFeedbackDetails(CATDetail:any,submittedCATSubmissionData:any) {
    for (let i = 0; i < CATDetail.length; i++) {
      if (CATDetail[i].fileName.startsWith("93006")) {
        let dataFilename = CATDetail[i].fileName.substring(0, CATDetail[i].fileName.indexOf('.'));
        if (CATDetail[i]["fileKind"] === 'FINRA-ACK') {
          if (submittedCATSubmissionData.length > 0) {
            for (let k = 0; k < submittedCATSubmissionData.length; k++) {
              if (dataFilename == submittedCATSubmissionData[k].fileName.substring(0, submittedCATSubmissionData[k].fileName.indexOf('.'))) {
                submittedCATSubmissionData[k]["finraRecordCount"] = CATDetail[i]["recordCount"];
                submittedCATSubmissionData[k]["finraFileModified"] = CATDetail[i]["fileModified"];
              }
            }
          }
        } else if (CATDetail[i]["fileKind"] === 'INGESTION') {
          if (submittedCATSubmissionData.length > 0) {
            for (let k = 0; k < submittedCATSubmissionData.length; k++) {
              if (dataFilename == submittedCATSubmissionData[k].fileName.substring(0, submittedCATSubmissionData[k].fileName.indexOf('.'))) {
                submittedCATSubmissionData[k]["ingestionRecordCount"] = CATDetail[i]["recordCount"];
                submittedCATSubmissionData[k]["ingestionFileModified"] = CATDetail[i]["fileModified"];
              }
            }
          }
        } else if (CATDetail[i]["fileKind"] === 'INTEGRITY') {
          if (submittedCATSubmissionData.length > 0) {
            for (let k = 0; k < submittedCATSubmissionData.length; k++) {
              if (dataFilename == submittedCATSubmissionData[k].fileName.substring(0, submittedCATSubmissionData[k].fileName.indexOf('.'))) {
                submittedCATSubmissionData[k]["integrityRecordCount"] = CATDetail[i]["recordCount"];
                submittedCATSubmissionData[k]["integrityFileModified"] = CATDetail[i]["fileModified"];
              }
            }
          }
        } else if (CATDetail[i]["fileKind"] === 'LINKAGE') {
          if (submittedCATSubmissionData.length > 0) {
            for (let k = 0; k < submittedCATSubmissionData.length; k++) {
              if (CATDetail[i]["reporter"] === submittedCATSubmissionData[k]["reporter"]) {
                submittedCATSubmissionData[k]["linkingRecordCount"] = CATDetail[i]["recordCount"];
                submittedCATSubmissionData[k]["linkingFileModified"] = CATDetail[i]["fileModified"];
              }
            }
          }
        }
      }
    }
  }

  prepareCATData(dataSet:any) {
    this.CATDataGroupDataSet = [];
    this.CATDataSet = [];
    if(dataSet.CATData.length > 0) {
      const groupNames = Object.keys(_.countBy(dataSet.CATData, function(data) { return data.groupName; }));

      for(let i=0; i<groupNames.length; i++) {
        let DBRowObj = dataSet.CATData.filter((row:any) => row.groupName===groupNames[i] && row.Source==='DB');
        let FileRowObj = dataSet.CATData.filter((row:any) => row.groupName===groupNames[i] && row.Source==='FILE');

        /* Group Summary */
        let DBRowTotal = ((DBRowObj.length > 0) ? DBRowObj[0]["total_In_Out_Count"] : 0);
        let JsonInputRowTotal = ((DBRowObj.length > 0) ? DBRowObj[0]["JSON_Input_Count"] : 0);
        let FileRowTotal = ((FileRowObj.length > 0) ? FileRowObj[0]["total_In_Out_Count"] : 0);
        this.CATDataGroupDataSet.push({"groupName": groupNames[i], "groupDetail": [{groupName: groupNames[i], IN: DBRowTotal, INEXCEPTION: JsonInputRowTotal, OUT: FileRowTotal, Matched: ((DBRowTotal+JsonInputRowTotal)===FileRowTotal ? "Matched": "UnMatched"), Differences: Math.abs(FileRowTotal-DBRowTotal-JsonInputRowTotal), tableName: "CAT Singular Group Detail Table"}]});

        /* Group Details */
        for(let j=0;j<this.eventTypes.length;j++) {
          let tableRowObj :any= {};

          if((DBRowObj.length > 0 && DBRowObj[0][this.eventTypes[j]+"_COUNT"] && DBRowObj[0][this.eventTypes[j]+"_COUNT"] > 0) || (FileRowObj.length > 0 && FileRowObj[0][this.eventTypes[j]+"_COUNT"] && FileRowObj[0][this.eventTypes[j]+"_COUNT"] > 0)) {
            let DBRowEventCount = (DBRowObj.length > 0 ? DBRowObj[0][this.eventTypes[j]+"_COUNT"] : 0);
            let FileRowEventCount = (FileRowObj.length > 0 ? FileRowObj[0][this.eventTypes[j]+"_COUNT"] : 0);
            tableRowObj["groupname"] = groupNames[i];
            tableRowObj["event"] = this.eventTypes[j];
            tableRowObj["InCount"] = DBRowEventCount;
            tableRowObj["OutCount"] = FileRowEventCount;
            tableRowObj["matched"] = (DBRowEventCount===FileRowEventCount ? "Matched" : "UnMatched");
            tableRowObj["countDifference"] = Math.abs(FileRowEventCount - DBRowEventCount);
            this.CATDataSet.push(tableRowObj);
          }
        }
      }
    }
  }

  prepareClientandCATData(dataSet:any) {
      /* Client-CAT Summary Data */
      let allocationRowObject = dataSet.ClientSummaryData.filter((rowData:any) => rowData.File_Name.toLowerCase().includes("allocation"));
      let orderRowObject = dataSet.ClientSummaryData.filter((rowData:any) => rowData.File_Name.toLowerCase().includes("ord"));
      let routeRowObject = dataSet.ClientSummaryData.filter((rowData:any) => rowData.File_Name.toLowerCase().includes("route"));
      let tradeRowObject = dataSet.ClientSummaryData.filter((rowData:any) => rowData.File_Name.toLowerCase().includes("trade"));

      let ClientNewEvents = 0, ClientModifiedEvents = 0, ClientCancelEvents = 0, ClientRouteEvents = 0, ClientOrderEffectiveEvents = 0, ClientChildEvents = 0, ClientAllocationEvents = 0, ClientInternalRouteEvents = 0, ClientExecutionEvents = 0;
      let CATNewEvents = 0, CATModifiedEvents = 0, CATCancelEvents = 0, CATRouteEvents = 0, CATOrderEffectiveEvents = 0, CATChildEvents = 0, CATAllocationEvents = 0, CATInternalRouteEvents = 0, CATExecutionEvents = 0;

      /* CAT File Events */
      if(dataSet['CATSummaryData'].length > 0) {
        for(let i=0; i<dataSet['CATSummaryData'].length; i++) {
          /* Get count of all CAT Events */
            CATNewEvents += dataSet['CATSummaryData'][i]['CATNewEvents'];
            CATModifiedEvents += dataSet['CATSummaryData'][i]['CATModifiedEvents'];
            CATCancelEvents += dataSet['CATSummaryData'][i]['CATCancelEvents'];
            CATRouteEvents += dataSet['CATSummaryData'][i]['CATRouteEvents'];
            CATOrderEffectiveEvents += dataSet['CATSummaryData'][i]['CATOrderEffectiveEvents'];
            CATChildEvents += dataSet['CATSummaryData'][i]['CATChildEvents'];
            CATAllocationEvents += dataSet['CATSummaryData'][i]['CATAllocationEvents'];
            CATInternalRouteEvents += dataSet['CATSummaryData'][i]['CATInternalRouteEvents'];
            CATExecutionEvents += dataSet['CATSummaryData'][i]['CATExecutionEvents'];
          /* End of getting count of all CAT Events */
          for(let j=0; j<this.eventTypes.length; j++) {
            if(dataSet['CATSummaryData'][i][this.eventTypes[j]]) {
              this.clientCATDetailDataSet.push({fileName: dataSet['CATSummaryData'][i]['File_Name'], eventType: this.eventTypes[j], 
              recordCount: dataSet['CATSummaryData'][i][this.eventTypes[j]]});
            }
          } 
        }
      }

      /* Client File Events */
      if(dataSet['ClientSummaryData'].length > 0) {
        for(let i=0; i<dataSet['ClientSummaryData'].length; i++) {
          /* Get count of all Client Events */
            ClientNewEvents += dataSet['ClientSummaryData'][i]['ClientNewEvents'];
            ClientModifiedEvents += dataSet['ClientSummaryData'][i]['ClientModifiedEvents'];
            ClientCancelEvents += dataSet['ClientSummaryData'][i]['ClientCancelEvents'];
            ClientRouteEvents += dataSet['ClientSummaryData'][i]['ClientRouteEvents'];
            ClientOrderEffectiveEvents += dataSet['ClientSummaryData'][i]['ClientOrderEffectiveEvents'];
            ClientChildEvents += dataSet['ClientSummaryData'][i]['ClientChildEvents'];
            ClientAllocationEvents += dataSet['ClientSummaryData'][i]['ClientAllocationEvents'];
            ClientInternalRouteEvents += dataSet['ClientSummaryData'][i]['ClientInternalRouteEvents'];
            ClientExecutionEvents += dataSet['ClientSummaryData'][i]['ClientExecutionEvents'];
          /* End of getting count of all Client Events */
        }
      }

      /* Allocation File Events */
      if(allocationRowObject.length > 0) {
        for(let i=0; i<allocationRowObject.length; i++) {
          for(let j=0; j<this.orderTypes.length; j++) {
            if(allocationRowObject[i]['A_'+this.orderTypes[j]]) {
              this.clientCATDetailDataSet.push({fileName: allocationRowObject[i]['File_Name'],
              eventType: this.orderTypes[j], recordCount: allocationRowObject[i]['A_'+this.orderTypes[j]]});
            }
          } 
        }
      }

      /* Order File Events */
      if(orderRowObject.length > 0) {
        for(let i=0; i<orderRowObject.length; i++) {
          for(let j=0; j<this.orderTypes.length; j++) {
            if(orderRowObject[i]['O_'+this.orderTypes[j]]) {
              this.clientCATDetailDataSet.push({fileName: orderRowObject[i]['File_Name'],
              eventType: this.orderTypes[j], recordCount: orderRowObject[i]['O_'+this.orderTypes[j]]});
            }
          } 
        }
      }

      /* Route File Events */
      if(routeRowObject.length > 0) {
        for(let i=0; i<routeRowObject.length; i++) {
          for(let j=0; j<this.orderTypes.length; j++) {
            if(routeRowObject[i]['R_'+this.orderTypes[j]]) {
              this.clientCATDetailDataSet.push({fileName: routeRowObject[i]['File_Name'],
              eventType: this.orderTypes[j], recordCount: routeRowObject[i]['R_'+this.orderTypes[j]]});
            }
          } 
        }
      }

      /* Trade File Events */
      if(tradeRowObject.length > 0) {
        for(let i=0; i<tradeRowObject.length; i++) {
          for(let j=0; j<this.orderTypes.length; j++) {
            if(tradeRowObject[i]['T_'+this.orderTypes[j]]) {
              this.clientCATDetailDataSet.push({fileName: tradeRowObject[i]['File_Name'],
               eventType: this.orderTypes[j], recordCount: tradeRowObject[i]['T_'+this.orderTypes[j]]});
            }
          } 
        }
      }

      this.clientCATDetailDataSet.map((data) => { data['tableName'] = "File Details Table"; }); // Set Table Name for Cell Value

      let clientEventTotalCount = (ClientNewEvents + ClientModifiedEvents + ClientCancelEvents + ClientRouteEvents + ClientOrderEffectiveEvents + ClientChildEvents + ClientAllocationEvents + ClientInternalRouteEvents + ClientExecutionEvents);
      let catEventTotalCount = (CATNewEvents + CATModifiedEvents + CATCancelEvents + CATRouteEvents + CATOrderEffectiveEvents + CATChildEvents + CATAllocationEvents + CATInternalRouteEvents + CATExecutionEvents);
      let clientcatEventTotalDifferenceCount = (Math.abs(ClientNewEvents - CATNewEvents) + Math.abs(ClientModifiedEvents - CATModifiedEvents) + Math.abs(ClientCancelEvents - CATCancelEvents) + Math.abs(ClientRouteEvents - CATRouteEvents) + Math.abs(ClientOrderEffectiveEvents - CATOrderEffectiveEvents) + Math.abs(ClientChildEvents - CATChildEvents) + Math.abs(ClientAllocationEvents - CATAllocationEvents) + Math.abs(ClientInternalRouteEvents - CATInternalRouteEvents) + Math.abs(ClientExecutionEvents - CATExecutionEvents));

      this.clientCATDataSet = [
        {clientDataEvents: "NW+BO", clientEventCount: ClientNewEvents, catEvents: "New Events", "catEventCount": CATNewEvents, "eventMatched": (ClientNewEvents === CATNewEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientNewEvents - CATNewEvents)},
        {clientDataEvents: "AJ+CR+UR+BM", clientEventCount: ClientModifiedEvents, catEvents: "Modified Events", "catEventCount": CATModifiedEvents, "eventMatched": (ClientModifiedEvents === CATModifiedEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientModifiedEvents - CATModifiedEvents)},
        {clientDataEvents: "CL+CC", clientEventCount: ClientCancelEvents, catEvents: "Cancel Events", "catEventCount": CATCancelEvents, "eventMatched": (ClientCancelEvents === CATCancelEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientCancelEvents - CATCancelEvents)},
        {clientDataEvents: "RT+RR+RC", clientEventCount: ClientRouteEvents, catEvents: "Route Events", "catEventCount": CATRouteEvents, "eventMatched": (ClientRouteEvents === CATRouteEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientRouteEvents - CATRouteEvents)},
        {clientDataEvents: "OE", clientEventCount: ClientOrderEffectiveEvents, catEvents: "Order Effective Events", "catEventCount": CATOrderEffectiveEvents, "eventMatched": (ClientOrderEffectiveEvents === CATOrderEffectiveEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientOrderEffectiveEvents - CATOrderEffectiveEvents)},
        {clientDataEvents: "CO", clientEventCount: ClientChildEvents, catEvents: "Child Events", "catEventCount": CATChildEvents, "eventMatched": (ClientChildEvents === CATChildEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientChildEvents - CATChildEvents)},
        {clientDataEvents: "AL+AA+AC", clientEventCount: ClientAllocationEvents, catEvents: "Allocation Events", "catEventCount": CATAllocationEvents, "eventMatched": (ClientAllocationEvents === CATAllocationEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientAllocationEvents - CATAllocationEvents)},
        {clientDataEvents: "DO+DM+DC+CD", clientEventCount: ClientInternalRouteEvents, catEvents: "Internal Route Events", "catEventCount": CATInternalRouteEvents, "eventMatched": (ClientInternalRouteEvents === CATInternalRouteEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientInternalRouteEvents - CATInternalRouteEvents)},
        {clientDataEvents: "TR", clientEventCount: ClientExecutionEvents, catEvents: "Execution Events", "catEventCount": CATExecutionEvents, "eventMatched": (ClientExecutionEvents === CATExecutionEvents ? 'Matched' : 'UnMatched'), "eventDifferences": Math.abs(ClientExecutionEvents - CATExecutionEvents)},
        {clientDataEvents: "Total", clientEventCount: clientEventTotalCount, catEvents: "All", "catEventCount": catEventTotalCount, "eventMatched": ((clientEventTotalCount === catEventTotalCount) ? 'Matched' : 'UnMatched'), "eventDifferences": clientcatEventTotalDifferenceCount},
      ];

      this.clientCATDataSet.map((data) => { data['tableName'] = "Event Summary Table"; }); // Set Table Name for Cell Value
  }

  prepareCATMonthlySummaryData(dataSet:any) {
    /* Receive all Available ReportDates */
    let catbaureportDates = [], catrepairreportDates = [], catexceptionreportDates = [];

    if(dataSet.CATBAUFileSummaryData.length > 0) {
      catbaureportDates = dataSet.CATBAUFileSummaryData.map((itemObj:any) => itemObj.reportDate);
    }
    if(dataSet.CATRepairFileSummaryData.length > 0) {
      catrepairreportDates = dataSet.CATRepairFileSummaryData.map((itemObj:any) => itemObj.reportDate);
    }
    if(dataSet.CATExceptionSummaryData.length > 0) {
      catexceptionreportDates = dataSet.CATExceptionSummaryData.map((itemObj:any) => itemObj.reportDate);
    }

    /* Prepare all Available unique ReportDates */
    let uniqueReportDates = _.union(catbaureportDates, catrepairreportDates, catexceptionreportDates);
    const sortedUniqueReportDates = uniqueReportDates.sort((a:any, b:any) => new Date(a).getTime() - new Date(b).getTime());

    /* Prepare Default CAT Monthly Summary Dataset */
    this.CATMonthlySummaryDataSet = [];
    if(sortedUniqueReportDates.length > 0) {
      for(let i=0; i < sortedUniqueReportDates.length; i++) {
        let recordObject = new Object({
            "reportDate": sortedUniqueReportDates[i], "bauFileCount": 0, "bauRecordCount": 0, "repairFileCount": 0, "repairRecordCount": 0, "warningCount": 0, "ingestionCount": 0, "intrafirmCount": 0, "interfirmCount": 0, "totalExceptionCount": 0, "Warning-ExceptionCodes": "", "Ingestion-ExceptionCodes": "", "Intra-Firm-ExceptionCodes": "", "Inter-Firm-ExceptionCodes": "", "Total-ExceptionCodes": "", "tableName": "CAT Monthly Summary Table"
        });
        this.CATMonthlySummaryDataSet.push(recordObject);
      }
    }

    /* Initiate All BAU/Repair/Execption final Totals for respectively available ReportDates */
    this.CATMonthlySummaryTotals = new Object({
      "totalBAUFileCount": 0, "totalBAURecordCount": 0, "totalRepairFileCount": 0, "totalRepairRecordCount": 0, "totalWarningCount": 0, "totalIngestionCount": 0, "totalIntrafirmCount": 0, "totalInterfirmCount": 0, "overAllExceptionCount": 0, "all-Warning-ExceptionCodes": "", "all-Ingestion-ExceptionCodes": "", "all-Intra-Firm-ExceptionCodes": "", "all-Inter-Firm-ExceptionCodes": "", "all-Total-ExceptionCodes": ""
    });

    /* Receive All BAU Count & their final Totals from API Response respectively available ReportDates */
    if(dataSet.CATBAUFileSummaryData.length > 0) {
      if(this.CATMonthlySummaryDataSet.length > 0) {
        for(let i=0; i < this.CATMonthlySummaryDataSet.length; i++) {
          let searchedCATBAUSummary = dataSet.CATBAUFileSummaryData.filter((itemObj:any) => itemObj.reportDate === this.CATMonthlySummaryDataSet[i].reportDate);
          if(searchedCATBAUSummary.length > 0) {
            this.CATMonthlySummaryDataSet[i].bauFileCount = searchedCATBAUSummary[0].bauFileCount;
            this.CATMonthlySummaryDataSet[i].bauRecordCount = searchedCATBAUSummary[0].bauRecordCount;
            this.CATMonthlySummaryTotals["totalBAUFileCount"] += searchedCATBAUSummary[0].bauFileCount;
            this.CATMonthlySummaryTotals["totalBAURecordCount"] += searchedCATBAUSummary[0].bauRecordCount;
          }
        }
      }
    }

    /* Receive All Repair Counts & their final Totals from API Response respectively available ReportDates */
    if(dataSet.CATRepairFileSummaryData.length > 0) {
      if(this.CATMonthlySummaryDataSet.length > 0) {
        for(let i=0; i < this.CATMonthlySummaryDataSet.length; i++) {
          let searchedCATRepairSummary = dataSet.CATRepairFileSummaryData.filter((itemObj:any) => itemObj.reportDate === this.CATMonthlySummaryDataSet[i].reportDate);
          if(searchedCATRepairSummary.length > 0) {
            this.CATMonthlySummaryDataSet[i].repairFileCount = searchedCATRepairSummary[0].repairFileCount;
            this.CATMonthlySummaryDataSet[i].repairRecordCount = searchedCATRepairSummary[0].repairRecordCount;
            this.CATMonthlySummaryTotals["totalRepairFileCount"] += searchedCATRepairSummary[0].repairFileCount;
            this.CATMonthlySummaryTotals["totalRepairRecordCount"] += searchedCATRepairSummary[0].repairRecordCount;
          }
        }
      }
    }

    /* Receive All Execption Counts, All Exception Codes & their final Totals from API Response respectively available ReportDates */
    if(dataSet.CATExceptionSummaryData.length > 0) {
      if(this.CATMonthlySummaryDataSet.length > 0) {
        for(let i=0; i < this.CATMonthlySummaryDataSet.length; i++) {
          let searchedCATExceptionSummary = dataSet.CATExceptionSummaryData.filter((itemObj:any) => itemObj.reportDate === this.CATMonthlySummaryDataSet[i].reportDate);
          if(searchedCATExceptionSummary.length > 0) {
            // Exception Counts
            this.CATMonthlySummaryDataSet[i].warningCount = searchedCATExceptionSummary[0].warningCount;
            this.CATMonthlySummaryDataSet[i].ingestionCount = searchedCATExceptionSummary[0].ingestionCount;
            this.CATMonthlySummaryDataSet[i].intrafirmCount = searchedCATExceptionSummary[0].intrafirmCount;
            this.CATMonthlySummaryDataSet[i].interfirmCount = searchedCATExceptionSummary[0].interfirmCount;
            this.CATMonthlySummaryDataSet[i].totalExceptionCount = (searchedCATExceptionSummary[0].warningCount + searchedCATExceptionSummary[0].ingestionCount + searchedCATExceptionSummary[0].intrafirmCount + searchedCATExceptionSummary[0].interfirmCount);

            // Exception Codes
            this.CATMonthlySummaryDataSet[i]["Warning-ExceptionCodes"] = searchedCATExceptionSummary[0].warningExceptions;
            this.CATMonthlySummaryDataSet[i]["Ingestion-ExceptionCodes"] = searchedCATExceptionSummary[0].ingestionExceptions;
            this.CATMonthlySummaryDataSet[i]["Intra-Firm-ExceptionCodes"] = searchedCATExceptionSummary[0].intrafirmExceptions;
            this.CATMonthlySummaryDataSet[i]["Inter-Firm-ExceptionCodes"] = searchedCATExceptionSummary[0].interfirmExceptions;
            // Total Exception Codes for Final Column Cell Values (Summation of Rows)
            let totalExceptionCodes = [searchedCATExceptionSummary[0].warningExceptions, searchedCATExceptionSummary[0].ingestionExceptions, searchedCATExceptionSummary[0].intrafirmExceptions, searchedCATExceptionSummary[0].interfirmExceptions];
            this.CATMonthlySummaryDataSet[i]["Total-ExceptionCodes"] = _.join(_.compact(totalExceptionCodes), ',');

            // Total Exception Counts for Opted Report Date Range
            this.CATMonthlySummaryTotals["totalWarningCount"] += searchedCATExceptionSummary[0].warningCount;
            this.CATMonthlySummaryTotals["totalIngestionCount"] += searchedCATExceptionSummary[0].ingestionCount;
            this.CATMonthlySummaryTotals["totalIntrafirmCount"] += searchedCATExceptionSummary[0].intrafirmCount;
            this.CATMonthlySummaryTotals["totalInterfirmCount"] += searchedCATExceptionSummary[0].interfirmCount;
            this.CATMonthlySummaryTotals["overAllExceptionCount"] += (searchedCATExceptionSummary[0].warningCount + searchedCATExceptionSummary[0].ingestionCount + searchedCATExceptionSummary[0].intrafirmCount + searchedCATExceptionSummary[0].interfirmCount);
          } else {
            this.CATMonthlySummaryDataSet[i].totalExceptionCount = 0;
          }
        }
      }
    }

    /* Receive All Exception Codes from API Response respectively overall Report Date Range */
    if(dataSet.CATFinraExceptionCodesData.length > 0) {
      this.CATMonthlySummaryTotals["all-Warning-ExceptionCodes"] = dataSet.CATFinraExceptionCodesData[0].warningExceptions;
      this.CATMonthlySummaryTotals["all-Ingestion-ExceptionCodes"] = dataSet.CATFinraExceptionCodesData[0].ingestionExceptions;
      this.CATMonthlySummaryTotals["all-Intra-Firm-ExceptionCodes"] = dataSet.CATFinraExceptionCodesData[0].intrafirmExceptions;
      this.CATMonthlySummaryTotals["all-Inter-Firm-ExceptionCodes"] = dataSet.CATFinraExceptionCodesData[0].interfirmExceptions;
      // Total Exception Codes for Final Cell Value
      let totalExceptionCodes = [dataSet.CATFinraExceptionCodesData[0].warningExceptions, dataSet.CATFinraExceptionCodesData[0].ingestionExceptions, dataSet.CATFinraExceptionCodesData[0].intrafirmExceptions, dataSet.CATFinraExceptionCodesData[0].interfirmExceptions];
      this.CATMonthlySummaryTotals["all-Total-ExceptionCodes"] = _.join(_.compact(totalExceptionCodes), ',');
    }

  }

  prepareAndSendContextMenuParams(commentCriteria: any, field?: any, fieldHeader?: any, groupName?: any) {
    /* Decide whether User has clicked for commenting on Table Header OR Table Cell */
    if(commentCriteria==="Header-Comments") {
      this.sendPreparedParams(commentCriteria, fieldHeader, field.tableName, groupName);
    } else if (commentCriteria==="Field-Comments") {
      this.sendContextMenuParameters(commentCriteria, field, fieldHeader);
    }

    this.openCatalystCommentViewer(false, true);
  }

  openCatalystCommentViewer(isDisplayDateRangeFilter: boolean, isDisplayAddCommentForm: boolean) {
    this.catReconService.isOpenCommentViewer = true;
    this.catReconService.isDisplayDateRangeFilter = isDisplayDateRangeFilter;
    this.catReconService.isDisplayAddCommentForm = isDisplayAddCommentForm;
  }

  sendPreparedParams(commentCriteria: any, fieldHeader?: any, fieldTableName?: any, groupName?: any) {
    /* Set Date Range for Retrieving Comments */
      let fromDate, toDate;
      if(this.selectedTabIndex===5 && this.hasUserOptedCATMonthlyFilter && commentCriteria!=="Browse-Comments") {
        fromDate = this.userService.getyyyyMMddDateFormate(this.CATMonthlyDateRangeFilter[0]);
        toDate = this.userService.getyyyyMMddDateFormate(this.CATMonthlyDateRangeFilter[1]);
      } else if (this.selectedTabIndex===5 && !this.hasUserOptedCATMonthlyFilter && commentCriteria!=="Browse-Comments") {
        fromDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(this.DefaultFilterArray[0].values[0])));
        toDate = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(this.DefaultFilterArray[0].values[1])));
      } else if(commentCriteria==="Browse-Comments") {
        fromDate = format(startOfMonth(new Date(this.DefaultFilterArray[0].values[0])), 'yyyy-MM-dd');
        toDate = format(endOfMonth(new Date(this.DefaultFilterArray[0].values[1])), 'yyyy-MM-dd');
      } else {
        fromDate = this.userService.getyyyyMMddDateFormate(this.reportDate);
        toDate = this.userService.getyyyyMMddDateFormate(this.reportDate);
      }
    /* End of Set Date Range for Retrieving Comments */

    this.selectedRowData = {commentSection: commentCriteria, optedTableHeader: fieldHeader, tableName: fieldTableName, 
      reportDate: this.userService.getyyyyMMddDateFormate(this.reportDate), 
      fromReportDate: fromDate, 
      toReportDate: toDate, 
      groupName: groupName};
  }

  sendContextMenuParameters(commentCriteria: any, rowFieldObj: any, fieldHeader: any) {
    if(fieldHeader.length > 0) {
      let selectedTableRowObj = _.cloneDeep(rowFieldObj); // Deep Clone Selected Table Row Object

      /* Set Date Range for Retrieving Comments */
        let fromDate, toDate;
        // Set Selected Row's ReportDate for CAT Monthly Summary Table Otherwise User Selected Filter ReportDate for rest of the Tables from various Tabs
        if(this.selectedTabIndex===5) {
          fromDate = this.userService.getyyyyMMddDateFormate(selectedTableRowObj.reportDate);
          toDate = this.userService.getyyyyMMddDateFormate(selectedTableRowObj.reportDate);
        } else {
          fromDate = this.userService.getyyyyMMddDateFormate(this.reportDate);
          toDate = this.userService.getyyyyMMddDateFormate(this.reportDate);
        }
      /* End of Set Date Range for Retrieving Comments */
      
      this.selectedRowData = Object.assign(selectedTableRowObj, {commentSection: commentCriteria, optedTableHeader: fieldHeader, 
      reportDate: this.userService.getyyyyMMddDateFormate(selectedTableRowObj.tableName === "CAT Monthly Summary Table" ? selectedTableRowObj.reportDate : this.reportDate), 
      fromReportDate: fromDate, 
      toReportDate: toDate, 
      fieldValue: rowFieldObj[fieldHeader[0]].toString()!=="" && rowFieldObj[fieldHeader[0]].toString()});
      this.selectedRowData = {...this.selectedRowData};
    }
  }

  getAllCommentCounts() {
    // Cancel All Previously Pending Status APIs
    if (this.CATReconCommentHTTPSubscribedAPI) {
      this.CATReconCommentHTTPSubscribedAPI.unsubscribe();
    }

    this.previousLimit = this.Limit;
    this.tbldatamsg = 'L o a d i n g . . . . .';

    let browseCommentFromDate = format(startOfMonth(new Date(this.DefaultFilterArray[0].values[0])), 'yyyy-MM-dd');
    let browseCommentToDate = format(endOfMonth(new Date(this.DefaultFilterArray[0].values[1])), 'yyyy-MM-dd');

    /* Default Tab Data */
    let defaultFilterData: any;
    // If User has selected Monthly Filter from Monthly Recon Summary Tab
    if(this.hasUserOptedCATMonthlyFilter) {
      defaultFilterData = JSON.parse(JSON.stringify(
        [{ "isdefault": "true", "label": "Date", "columnname": "reportDate", "filterby": "IS", "values": [this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.CATMonthlyDateRangeFilter[0])), this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.CATMonthlyDateRangeFilter[1]))], "time": "", "datatype": "DateRange", "disabled": "true", "dropdown": "", "dropdownvalue": "" }]
      ));
    } else {
      defaultFilterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    }
    defaultFilterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFilterData[0].values[0])));
    defaultFilterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(defaultFilterData[0].values[1])));

    let filterData = {
      CATReporterIMID: this.userService.getActiveMPID(),
      groupName: this.selectedRowData.groupName,
      reportDate: this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(this.reportDate))),
      browseCommentFromDate: browseCommentFromDate,
      browseCommentToDate: browseCommentToDate,
      panelName: this.panelNames[this.selectedTabIndex],
      tableName: this.selectedRowData.tableName,
      rowKey: this.selectedRowData.clientDataEvents,
      Comment: this.commentStatement,
      columnKey: "",
      createdBy: this.userService.getUserName(),
      updatedBy: this.userService.getUserName(),
      data: defaultFilterData // Default Filter Data
    };

    this.CATReconCommentHTTPSubscribedAPI = this.catReconService.getAllCatReconCommentColumnCount(filterData)    
    .subscribe({
      next: (Element: any) => {
        let dataset: any = Element;
      this.resetCounts(); // Reset all Comment Counts
      // Re-calculate Finra Submission/Rejection comment Counts After Inserting/Deleting Comment
      this.prapareCATGroupByCount(dataset.Data['catGroupData']); // Calculate Comment Counts of multiple CAT Data Group By Tables
      this.prepareCount(this.clientCATSummaryCols, dataset.Data['clientCAT']);
      this.prepareCount(this.clientCATDetailCols, dataset.Data['clientCAT']);
      this.prepareCount(this.clientDataCols, dataset.Data['clientData']);
      this.prepareCount(this.catDataCols, dataset.Data['catData']);
      this.prepareCount(this.correctedCATSubmissionCols, dataset.Data['catSubmission']);
      this.prepareCount(this.submittedCATSubmissionCols, dataset.Data['catSubmission']);
      this.prepareCount(this.catMonthlyFinraSubmissionSummaryCols, dataset.Data['catMonthlySummary']);
      this.prepareCount(this.catMonthlyFinraRejectionSummaryCols, dataset.Data['catMonthlySummary']);
      this.totalCommentsCount = (dataset.Data['browsedCommentCount'] ? dataset.Data['browsedCommentCount'][0]['CNT'] : 0);
      },
      error: (err: HttpErrorResponse) => {
          console.error(err);
      }
    });
  }

  prepareCount(columnMap:any[], reconData:any[]) {
    columnMap.map(column => {
      if(reconData && reconData.length > 0) {
        for(let i=0; i < reconData.length; i++) {
          if(reconData[i].columnKey === column.field && reconData[i].tableName === column.tableName) {
           column["count"] = reconData[i].CNT;
          }
        }
      } else {
        column["count"] = 0;
      }
    });
  }

  /* Calculate Comment Counts of multiple CAT Data Group By Tables */
  prapareCATGroupByCount(reconData:any[]) {
    this.CATGroupByCommentCount = new Object();
    if(reconData.length > 0) {
      for(let i=0; i<reconData.length; i++) {
        this.CATGroupByCommentCount[reconData[i]["groupName"]] = [];
        this.CATGroupByCommentCount[reconData[i]["groupName"]].push({"IN": reconData[i]["totalIN"], "INEXCEPTION": reconData[i]["totalINEXCEPTION"], "OUT": reconData[i]["totalOUT"], "Differences": reconData[i]["totalDifferences"]});
      }
    }
  }

  resetCounts() {
    this.resetCount(this.clientCATSummaryCols);
    this.resetCount(this.clientCATDetailCols);
    this.resetCount(this.clientDataCols);
    this.resetCount(this.catDataGroupSummaryCols);
    this.resetCount(this.catDataCols);
    this.resetCount(this.correctedCATSubmissionCols);
    this.resetCount(this.submittedCATSubmissionCols);
    this.resetCount(this.catMonthlyFinraSubmissionSummaryCols);
    this.resetCount(this.catMonthlyFinraRejectionSummaryCols);
    this.resetCount(this.missingCATRecordsCols);
    this.resetCount(this.missingClientRecordsCols);
  }

  resetCount(columnMap:any[]) {
    columnMap.map(column => {    
      column["count"] = 0;   
    });
  }

  exportCATMonthlySummaryToCSV() {
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});

    /* Check whether User has Opted CAT Monthly Filter OR CAT Recon Default Filter */
    let filterData: any;
    if(this.hasUserOptedCATMonthlyFilter) {
      filterData = JSON.parse(JSON.stringify(
        [{ "isdefault": "true", "label": "Date", "columnname": "reportDate", "filterby": "IS", "values": [this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.CATMonthlyDateRangeFilter[0])), this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.CATMonthlyDateRangeFilter[1]))], "time": "", "datatype": "DateRange", "disabled": "true", "dropdown": "", "dropdownvalue": "" }]
      ));
    } else {
      filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    }

    // Export CAT Monthly Summary Detail CSV
    if(this.CATMonthlySummaryDataSet.length===0) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
      this.userService.logUserActivity('Export CSV', 'CAT Recon Monthly Summary', {
        'Text1': 'No data found',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    } else {
      let CSVData = "";
      let CATMonthlySummaryTableData:any = [];

      /* Prepare CAT Summary Rows */
      if(this.CATMonthlySummaryDataSet.length > 0) {
        let CSVGridHeaders = [...this.catMonthlyFinraSubmissionSummaryCols.map(function(gridItem:any) {return gridItem["header"]}), ...this.catMonthlyFinraRejectionSummaryCols.map(function(gridItem:any) {return gridItem["header"]})];
        let CSVGridFields = [...this.catMonthlyFinraSubmissionSummaryCols.map(function(gridItem:any) {return gridItem["field"]}), ...this.catMonthlyFinraRejectionSummaryCols.map(function(gridItem:any) {return gridItem["field"]})];
        CATMonthlySummaryTableData = this.userService.prepareCSVDataSet(CSVGridHeaders, CSVGridFields, this.CATMonthlySummaryDataSet);
      }
      /* Prepare CAT Summary Rows with Formatting */
      if(CATMonthlySummaryTableData.length > 0) {
        for(let i=0; i < CATMonthlySummaryTableData.length; i++) {
          let addCharPosition = this.findNthOccur(CATMonthlySummaryTableData[i], ",", 5);
          CATMonthlySummaryTableData[i] = CATMonthlySummaryTableData[i].slice(0, addCharPosition) + ",," + CATMonthlySummaryTableData[i].slice(addCharPosition);
        }
      }

      /* Prepare CAT Summary Total Row with Formatting */
      let Totals = Object.keys(this.CATMonthlySummaryTotals).map((ObjKey) => this.CATMonthlySummaryTotals[ObjKey]);
      Totals.unshift("Totals");Totals.splice(5, 0, "");Totals.splice(5, 0, "");

      /* Prepare CSV Rows */
      CSVData += 'RSMS_CAT_Monthly_Summary_Detail_' + this.userService.getyyyyMMddDateFormate(new Date()) + "\n\n";
      CSVData += "************CAT Monthly Summary Data************\n\n";
      CSVData += ",,FINRA CAT Submission,,,,,,Open FINRA Rejection Count,,,\n";
      CSVData += (CATMonthlySummaryTableData.length > 0 ? CATMonthlySummaryTableData.join("\n") : "No Data Found") + "\n\n";
      CSVData += Totals.join(",");

      /* Download CSV Procedure */
      let fileName = this.userService.getActiveMPID() + '_RSMS_CAT_Monthly_Summary_Viewer_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()) + ".csv";
      const a = document.createElement("a");
      a.href = URL.createObjectURL(new Blob([CSVData], { type: "text/csv" }));
      a.setAttribute("download", fileName);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
      this.userService.logUserActivity('Export CSV', 'CAT Recon Monthly Summary', {
        'Text1': 'File Download Successfully | CAT Monthly Summary Data Count: ' + (this.CATMonthlySummaryDataSet.length > 0 ? this.CATMonthlySummaryDataSet.length : 0) + ' records downloaded with file name: ' + fileName + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(filterData.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
    }
  }

  /* Find Nth Occurence of Substring from a String */
  findNthOccur(str:any, ch:any, N:any) {
    let occur = 0;
    // Loop to find the Nth occurrence of the character
    for (let i = 0; i < str.length; i++) {
        if (str[i] == ch) {
          occur += 1;
        }
        if (occur == N)
          return i;
    }
    return -1;
  }

  /* Redirect to Finra Exception screen for analyzing Exceptions */
  goToFinraExceptionViewer(exceptionRowReportDate?: any, fieldName?: any, fieldValue?: any, finraExceptions?: any) {
    if(fieldValue < 1000000) {
      /* Check User is clicking on Single Date Exception count OR Total of Exception Count */
      let initialReportDate, endReportDate;
      if(exceptionRowReportDate) {
        let exceptionReportDate = this.userService.getFormatedDate(format(new Date(exceptionRowReportDate), 'yyyy-MM-dd'));
        initialReportDate = exceptionReportDate;
        endReportDate = exceptionReportDate;
      } else {
        if(this.hasUserOptedCATMonthlyFilter) {
          initialReportDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.CATMonthlyDateRangeFilter[0]));
          endReportDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(this.CATMonthlyDateRangeFilter[1]));
        } else {
          initialReportDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(this.DefaultFilterArray[0].values[0]))));
          endReportDate = this.userService.getFormatedDate(this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(this.DefaultFilterArray[0].values[1]))));
        }
      }
      let urlParams = {
        "callFromScreen": "catreconmonthlysummary",
        "fieldName": fieldName,
        "activeMPID": this.userService.getActiveMPID(),
        "reportDate": [initialReportDate, endReportDate],
        "modifiedFlag": ['N', 'U', 'C'],
        "failureCode": finraExceptions
      };

      /* Catch User Action Log */
      this.userService.logUserActivity("Reviewed Finra-Exception Records", null, {
        'Text1': this.userService.userFirstName + ' reviewed Finra-Exception records from CAT Recon',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(urlParams)
      });

      this.router.navigate([]).then(result => {  window.open('/#/pages/CAT/Finra-Exception?'+btoa(JSON.stringify(urlParams)), '_blank'); });
    } else {
      this.confirmationService.confirm({
        message: 'Number of exceptions exceed maximum allowed count for the pop-up',
        key: 'informationDialoge',
        accept: () => {
        }
      });
    }
  }

  onContextMenu(event: any, params: any) {
    if(params.length > 0) {
      this.commentCriteria = params[0];
      this.commentField = params[1];
      this.commentFieldHeader = params[2];
      this.commentGroupName = params[3];
    }

    this.cm.target = event.currentTarget;
    this.cm.show(event);   
}

getClientandCATMissingData(filterData?: any, reconType?:any,field_Name?:any,index?:any) {
  if(reconType == 'U'){
    this.previousLimit = this.limitForUnderReporting;
  }
  else{
    this.previousLimit = this.limitForMissingData;
  }
  if(reconType == 'U'){
    this.isForUnderReportingLoadingResults =true;
  }
  else{
    this.isForMissingDataLoadingResults = true;
  }
  if(reconType == 'U'){
    filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
    if(filterData[0].values.length === 2) {
      filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
      filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }
    if(this.selectedGroup){
      filterData[1].values =this.selectedGroup;
    }
  }else{
      filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
      if(filterData[0].values.length === 2) {
        filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
        filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
    }
        if(this.selectedGroup){
      filterData[1].values = this.selectedGroup;
    }
  }
  let payload = {
    data: filterData,
    MPID:this.userService.getActiveMPID(),
    reconType:reconType,
    category:this.category,
    startLimit: reconType == 'U' ? this.limitForUnderReporting.Start.toString() : this.limitForMissingData.Start.toString(),
    endLimit: reconType == 'U' ? this.limitForUnderReporting.End.toString() : this.limitForMissingData.End.toString()
  }

  this.sharedHttpClientService.post(
    this.urlsService.setAPIURl(
      APIURL.CAT_RECON_MISSING_DATA
    ), payload
  )
  .subscribe({
    next: (Element: any) => {
      let dataset: any = Element.data;
      if(reconType === "U"){
        this.missingCATRecordData = dataset.data || [];
        this.totalRecordsCATRecord = dataset.totalCount || 0;
        this.totalRecordsCATRecord = this.gridService.handleNoRecordsPageNumber(this.totalRecordsCATRecord);
      }
      else if(reconType === "M"){
        this.missingClientData = dataset.data || [];
        this.totalRecordsMissinClient = dataset.totalCount || 0;
        this.totalRecordsMissinClient = this.gridService.handleNoRecordsPageNumber(this.totalRecordsMissinClient);
        }
        if(reconType == 'U'){
          this.isForUnderReportingLoadingResults =false;
        }
        else{
          this.isForMissingDataLoadingResults = false;
        }  
        },
    error: (err: HttpErrorResponse) => {
      if(reconType == 'U'){
        this.isForUnderReportingLoadingResults =false;
      }
      else{
        this.isForMissingDataLoadingResults = false;
      }     }
  });
}
displayClientAndCATMissingData(index:any,field_Name:any){
  // set current page as 1 when we switch the row
  this.dt1.first =1;
  this.dt2.first =1;
  const categoryDetails:{[key:number]:string}={
    0:field_Name == 'NW+BO' ? 'NW' : 'NW',
    1:field_Name == 'AJ+CR+UR+BM' ? 'CR' : 'CR',
    2:field_Name == 'CL+CC' ? 'CL' : 'CL',
    3:field_Name == 'RT+RR+RC' ? 'RT' : 'RT',
    4:'OE',
    5:'CO',
    6:field_Name == 'AL+AA+AC' ? 'AL' : 'AL',
    7:field_Name == 'DO+DM+DC+CD' ? 'DO' : 'DO',
    8:'TR',
    9:'',
  }
  this.category = categoryDetails[index] || '';
  let filterData;
  if(this.reconTypeForUnderReporting){
  filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
  if(filterData[0].values.length === 2) {
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
  }
}
else{
  filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
  if(filterData[0].values.length === 2) {
    filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
    filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
  }
}
  this.getClientandCATMissingData(filterData,this.reconTypeForUnderReporting,field_Name,index);
  this.getClientandCATMissingData(filterData,this.reconTypeForMissingData,field_Name,index);
}
toggleRowSelection(index:number,field_Name:any){
  if(this.selectRowIndex === index){
    this.selectRowIndex =null;
    this.displayClientAndCATMissingData('','')
  }
  else{
  this.selectRowIndex=index;
  this.displayClientAndCATMissingData(index,field_Name)
  }
}

openOrderID(value:any,rowData:any){
  if (value == 'OrderID') {
      this.emitterService.isOrderViewerOpenCloseEvent.emit(
        {
          display: true,
          rowData: rowData,
          pageName: 'CAT-RECON'
        });
    }
}
exportToCSV(event:any,reconType:any){
  let dataset: any =[];
  const options: any = {
    fieldSeparator: ',',
    quoteStrings: '"',
    decimalSeparator: '.',
    showLabels: true,
    showTitle: true,
    title: 'RSMS_CAT_Recon_' + this.userService.getyyyyMMddDateFormate(new Date()),
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
    filename: this.userService.getActiveMPID() +'_RSMS_CAT_Recon_' + this.userService.getyyyyMMdd_HH_MM_SSDateFormate(new Date()),
  };
  dataset = reconType == 'U' ? this.missingCATRecordData : this.missingClientData;
  let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'});
    if (event.isExportMaxRows) {
      let filterData;
      if(reconType == 'U'){
        filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
        if(filterData[0].values.length === 2) {
          filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
          filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
        }
      }
      else{
        filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
        if(filterData[0].values.length === 2) {
          filterData[0].values[0] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[0])));
          filterData[0].values[1] = this.userService.getyyyyMMddDateFormate(JSON.parse(JSON.stringify(filterData[0].values[1])));
        }
      }
    let payload = {
      data: filterData,
      MPID:this.userService.getActiveMPID(),
      reconType:reconType,
      category:this.category,
      startLimit: "0",
      endLimit: this.constantService.NUMBER_MAX_EXPORT_ROWS.toString()
    }
    this.sharedHttpClientService.post(
      this.urlsService.setAPIURl(
        APIURL.CAT_RECON_MISSING_DATA
      ),
      payload
    ).subscribe({
      next:(Element:any) => {
        dataset = [];
        dataset = Element.data;
        dataset = dataset.data;
        const csvExporter = this.constantService.getExportData(dataset, event.gridColumn);
        const csv = generateCsv(options)(csvExporter);
        const blob = asBlob(options)(csv);
        saveAs(blob,options.filename);
        this.userService.logUserActivity('Export CSV', null, {
          'Text1': 'File Download Successfully | ' + (dataset.length > 0 ? dataset.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
          'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
        });

    },
    error: (err: HttpErrorResponse) => {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error while Exporting' });
      this.userService.logUserActivity('Export CSV', null, {
        'Text1': 'Error while Exporting',
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });
  }});
}
else{
if (dataset.length > 0) { 
  const csvExporter = this.constantService.getExportData(dataset, event.gridColumn);
  const csv = generateCsv(options)(csvExporter);
  const blob = asBlob(options)(csv);
  saveAs(blob,options.filename);

  this.userService.logUserActivity('Export CSV', null, {
    'Text1': 'File Download Successfully | ' + (dataset.length > 0 ? dataset.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit'}),
    'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
  });
} else {
  this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
  this.userService.logUserActivity('Export CSV', null, {
    'Text1': 'No data found',
    'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
  });
}
}
this.emitterService.exportToCSVData.emit(true);
}
  changePageCATREcords(event: any) {
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
    this.startLimitForUnderReporting = event.first;
    this.endLimitForUnderReporting = this.startLimitForUnderReporting + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimitForUnderReporting > this.totalRecordsCATRecord) {
      this.endLimitForUnderReporting = this.totalRecordsCATRecord;
    }
    this.limitForUnderReporting = { 'Start': this.startLimitForUnderReporting, 'End': this.rowcount };
    this.previousLimit = this.startLimitForUnderReporting;
    this.pageNumber = Math.round(this.startLimitForUnderReporting / this.rowcount) + 1;
    this.getClientandCATMissingData(filterData, "U");
  }
  changePageMissingRecords(event: any) {
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
    this.startLimitForMissingData = event.first;
    this.endLimitForMissingData = this.startLimitForMissingData + this.rowcount;
    this.rowcount = event.rows;

    if (this.endLimitForMissingData > this.totalRecordsMissinClient) {
      this.endLimitForMissingData = this.totalRecordsMissinClient;
    }
    this.limitForMissingData = { 'Start': this.startLimitForMissingData, 'End': this.rowcount };
    this.previousLimit= this.startLimitForMissingData;
    this.pageNumber = Math.round(this.startLimitForMissingData / this.rowcount) + 1;
    this.getClientandCATMissingData(filterData, "M");
  }

sort(event:any,reconType:any) {
  if(this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
    this.sortClickCounter = this.sortClickCounter + 1;
  } else {
    this.sortClickCounter = 1;
  }
  if(this.sortClickCounter !== 3) {
    let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
    this.sortData.field = event.multisortmeta[0].field;
    this.sortData.order = sortOrder;
    if(reconType === 'U'){
    this.missingCATRecordData = this.sortPipe.transform(this.missingCATRecordData, this.sortData.order, this.sortData.field);
    }
    else if(reconType === 'M'){
      this.missingClientData = this.sortPipe.transform(this.missingClientData, this.sortData.order, this.sortData.field);
    }
  } else {
    if(this.dt.multiSortMeta != undefined && this.dt.multiSortMeta?.length > 0) {
    this.dt.multiSortMeta[0].field = '';
    this.dt.multiSortMeta[0].order = 0;
    }
  }
  
}
updateDefaultArray($event: any, reconType:any) {
  this.emitterService.ResetQuickFilterPanelEvent.emit("All"); 
  this.pageNumber = this.constantService.DEFAULT_PAGENUMBER; 
  const groupFilter = $event.find((f: any) => f.columnname === 'groupName');
  if (groupFilter && groupFilter.values !== this.selectedGroup) {
    this.selectedGroup = null;
  }
  if(reconType == 'U'){
    this.DefaultFilterArrayForUnderReporting = $event;
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
    this.dt1.first = 1;
    this.getClientandCATMissingData(filterData, "U");
  }
  else{
    this.DefaultFilterArrayForMissingData = $event;
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
    this.dt2.first = 1;
    this.getClientandCATMissingData(filterData, "M");
  }
}

clearQuickSearch($event: any , reconType:any) {
  this.emitterService.ResetQuickFilterPanelEvent.emit("All"); 
  this.pageNumber = this.constantService.DEFAULT_PAGENUMBER;
  if(reconType == 'U'){
    this.DefaultFilterArrayForUnderReporting = $event;
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
    this.dt1.first = 1;
    this.getClientandCATMissingData(filterData, "U");
  }
  else{
    this.DefaultFilterArrayForMissingData = $event;
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
    this.dt2.first = 1;
    this.getClientandCATMissingData(filterData, "M");
  }
}
syncDate(datevalues:any){
  this.DefaultFilterArrayForUnderReporting.forEach((filterdate:any)=>{
    if(filterdate.columnname === 'reportDate'){
      filterdate.values = datevalues;    
      }
  })
  this.DefaultFilterArrayForMissingData.forEach((filterdate:any)=>{
    if(filterdate.columnname === 'reportDate'){
      filterdate.values = datevalues; 
      }
  })
}
syncgroup(groupvalues:any){
  this.DefaultFilterArrayForUnderReporting.forEach((filtergroup:any)=>{
    if(filtergroup.columnname === 'groupName'){
      filtergroup.values = groupvalues;    
      }
  })
  this.DefaultFilterArrayForMissingData.forEach((filtergroup:any)=>{
    if(filtergroup.columnname === 'groupName'){
      filtergroup.values = groupvalues; 
      }
  })
}
  toggleSelectedGroupData(name:any,label: any) {
    /* Add GroupName value in Default Filter */
      let typeIndex = this.DefaultFilterArray.findIndex((row: { columnname: string; }) => row.columnname==='groupName');
      if(typeIndex > 0) {
        this.DefaultFilterArray[typeIndex]['values'] = ((this.selectedGroup === label) ? "" : label);
      }
    /* End of Adding GroupName value in Default Filter */

    if (this.selectedGroup === label) {
      this.selectedGroup = null;
    }
    else {
      this.selectedGroup = label
      this.getGroupData(name,label);
    }
  }
  getGroupData(name:any,groupName: any) {
    this.groupNames = groupName;
    const filterDataforU =JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
    const filterDataForM =JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));

    /* Catch User Action Log */
      this.userService.logUserActivity("User Applied Group Filter", this.constantService.getApplicationName(), {
        'Text1': this.userService.userFirstName + ' Applied Group Filter in ' + this.constantService.getApplicationName(),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });

    this.getClientandCATData(filterData);
    this.getClientandCATMissingData(filterDataforU, "U",name);
    this.getClientandCATMissingData(filterDataForM, "M",name);
  }
  clearGroup(event: any) {
    /* Clear GroupName value in Default Filter */
      let typeIndex = this.DefaultFilterArray.findIndex((row: { columnname: string; }) => row.columnname==='groupName');
      if(typeIndex > 0) {
        this.DefaultFilterArray[typeIndex]['values'] = '';
      }
    /* End of Clearing GroupName value in Default Filter */

    /* Catch User Action Log */
      this.userService.logUserActivity("User Removed Group Filter", this.constantService.getApplicationName(), {
        'Text1': this.userService.userFirstName + ' Removed Group Filter in ' + this.constantService.getApplicationName(),
        'Text2': 'User Filter Parameters: ' + JSON.stringify(this.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
      });

    this.selectedGroup = '';
    const filterDataforU =JSON.parse(JSON.stringify(this.DefaultFilterArrayForUnderReporting));
    const filterDataForM =JSON.parse(JSON.stringify(this.DefaultFilterArrayForMissingData));
    const filterData = JSON.parse(JSON.stringify(this.DefaultFilterArray));
    this.getClientandCATData(filterData);
    this.getClientandCATMissingData(filterDataforU,"U");
    this.getClientandCATMissingData(filterDataForM,"M");
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
      this.CATReconSummaryHTTPSubscribedAPI.unsubscribe();
      this.CATReconCommentHTTPSubscribedAPI.unsubscribe();
  }

}